import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import {
  TextField,
  Grid,
  Button,
  Divider,
  Typography,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  MenuItem,
} from "@material-ui/core";

import { Page } from "components";
import serviciosTablero from "utils/serviciosTablero";
import { Autocomplete } from "@material-ui/lab";
import { Controller } from "react-hook-form";
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";

const FormCompartir = ({
  idtablero,
  ctls,
  setCtls,
  eliminarParticipantes,
  idjerarquia,
  usuario,
  ...props
}) => {
  const [cargando, setCargando] = useState(false);
  const [mensaje, setMensaje] = useState({ open: false });
  const [nombres, setNombres] = useState([]);
  const [miembros, setMiembros] = useState([]);
  const { register, errors, setValue, control } = useFormContext();
  const [mAdvertencia, setMAdvertencia] = useState({
    open: false,
    data: null,
  });

  const cerrarAdvertencia = () => {
    setMAdvertencia({ open: false, data: null });
  };

  const classesTablero = useStylesTablero();

  const cerrarMensaje = () => setMensaje({ open: false });

  const opcionesParticipantes = [
    { label: "Admin", value: 2 },
    { label: "Miembro", value: 1 },
    { label: "Remover", value: -1 },
  ];

  const updateJerarquia = (event) => {
    let data = event.target.value.split(",");
    if (data[0] == -1) {
      setMAdvertencia({
        open: true,
        mensajeConfirmacion: "¿Desea remover este miembro del tablero?",
        confirmar: () => {
          cerrarAdvertencia();
          eliminarParticipantes({
            idtablero: idtablero,
            idjerarquia: data[0],
            idusuario: data[1],
          });
        },
      });
      return;
    }
    serviciosTablero.updateMiembroTablero(
      (status, mensaje, data) => {
        setMensaje({ open: true, status: status, value: mensaje });
        if (status > 0)
          setCtls({
            ...ctls,
            participantes: data?.participantes || [],
            clearOptions: false,
          });
      },
      setCargando,
      {
        idtablero: idtablero,
        idjerarquia: data[0],
        idusuario: data[1],
      }
    );
  };

  useEffect(() => {
    if (ctls?.clearOptions)
      document.querySelector(".MuiAutocomplete-clearIndicator")?.click();
  }, [ctls]);

  return (
    <Page
      title="Tablero"
      className={{}}
      mensaje={{ ...mensaje, cerrar: cerrarMensaje }}
      cargando={cargando}
    >
      <Grid container spacing={1}>
        <Grid xs={10}>
          <Controller
            control={control}
            name="participantes"
            {...register("participantes", {
              required: { value: true, message: "Campo requerido" },
            })}
            defaultValue={[]}
            render={(props) => (
              <Autocomplete
                multiple
                id="tags-standard-participantes"
                options={ctls?.participantesDisponibles || []}
                defaultValue={[]}
                onChange={(event, item) => {
                  setValue("participantes", item.length > 0 ? item : []);
                }}
                getOptionLabel={(option) => option.nombre}
                className={classesTablero.autoComplete}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Participantes disponibles"
                    name="participantesTxt"
                    helperText={errors?.participantes?.message}
                    error={errors?.participantes}
                    className={classesTablero.field}
                    id={"text-input-autocomplete-participantes"}
                  />
                )}
              />
            )}
          />
        </Grid>
        <Grid xs={2} style={{ padding: "10px" }}>
          <Button
            variant="filled"
            className={classesTablero.btnAceptar}
            type="submit"
            disabled={
              idjerarquia == 2 ? false : ![2, 3].includes(usuario[0]?.idrol)
            }
          >
            Compartir
          </Button>
        </Grid>
        <Grid xs={12} style={{ marginTop: "30px" }}>
          <Typography style={{ color: "#3E7EE0", fontWeight: "bold" }}>
            Miembros del tablero
          </Typography>
          <Divider style={{ backgroundColor: "#3E7EE0" }} />
        </Grid>
        <Grid xs={12}>
          <Grid container spacing={1} style={{ margin: "12px" }}>
            {(ctls?.participantes || []).map((miembro) => {
              return (
                <Grid xs={12} style={{ margin: "10px" }}>
                  <Grid container spacing={1}>
                    <Grid xs={1}>
                      <Avatar
                        style={{
                          fontSize: "10.5pt",
                          width: "30px",
                          height: "30px",
                          marginTop: "-5px",
                          backgroundColor: miembro?.color || "blue",
                          color: "#FFFF",
                        }}
                      >
                        {miembro.avatar || "00"}
                      </Avatar>
                    </Grid>
                    <Grid xs={8}>
                      <Grid container spacing={1}>
                        <Grid
                          xs={12}
                          style={{ fontFamily: "Arial", fontSize: "10.5pt" }}
                        >
                          {miembro.nombre}
                        </Grid>
                        <Grid
                          xs={12}
                          style={{ fontFamily: "Arial", fontSize: "7.5pt" }}
                        >
                          {miembro.correo}
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid
                      xs={2}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "end",
                        alignItems: "flex-end",
                      }}
                    >
                      <TextField
                        id="standard-select-currency-native"
                        select
                        label={
                          opcionesParticipantes.find(
                            (opcion) => opcion.value === miembro.idjerarquia
                          )?.label || ""
                        }
                        value={null}
                        onChange={updateJerarquia}
                        name="jerarquia"
                        variant="outlined"
                        size="small"
                        defaultValue={
                          miembro.idjerarquia + "," + miembro.idusuario
                        }
                        fullWidth
                        InputLabelProps={{ shrink: false }}
                        className={classesTablero.field}
                        disabled={
                          idjerarquia == 2
                            ? false
                            : ![2, 3].includes(usuario[0]?.idrol)
                        }
                      > 
                        {opcionesParticipantes.map((option) => (
                          <MenuItem
                            key={option.value}
                            value={option.value + "," + miembro.idusuario}
                            className={classesTablero.menuItem  }
                          >
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      </Grid>
      <Dialog
        open={mAdvertencia.open}
        onClose={cerrarAdvertencia}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle className={classesTablero.dialogTitle}>
          Advertencia
        </DialogTitle>
        <DialogContent className={classesTablero.dialogContent}>
          <DialogContentText className={classesTablero.dialogText}>
            {mAdvertencia.mensajeConfirmacion}
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classesTablero.dialogActions}>
          <Button
            onClick={cerrarAdvertencia}
            className={classesTablero.btnCancelar}
          >
            Cerrar
          </Button>
          {mAdvertencia?.confirmar && (
            <Button
              onClick={mAdvertencia.confirmar} // Confirma y envía los datos
              className={classesTablero.btnAceptar}
            >
              Confirmar
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Page>
  );
};

export default FormCompartir;
